import { isTimeRangeIntersects } from './date';

import type { CustomReportOffer } from 'types';

type CustomReportFilters = {
  startDate: string | undefined | null,
  endDate: string | undefined | null,
  searchQuery: string
};

export function getSelectedOnly(data: Array<CustomReportOffer>, checkedIdsSnapshot: Array<number>): Array<CustomReportOffer> {
  return data.reduce<Array<CustomReportOffer>>((result, group) => {
    const selectedDeliverables = group.deliverables
      .filter((deliverable) => checkedIdsSnapshot.includes(deliverable.id));

    if (selectedDeliverables.length > 0) {
      return result.concat([{
        ...group,
        deliverables: selectedDeliverables
      }]);
    }
    return result;
  }, []);
}

export function filterCustomReportDate(data: Array<CustomReportOffer>, filters: CustomReportFilters): Array<CustomReportOffer> {
  const { startDate, endDate, searchQuery } = filters;

  return data.reduce<Array<CustomReportOffer>>((result, group) => {
    const filteredDeliverables = group.deliverables.filter((deliverable) => {
      const hasNoFilters = !startDate && !endDate && !searchQuery;

      if (hasNoFilters) {
        return true;
      }

      // either user name or deliverable name matches query
      const isMatchedByName = searchQuery
        && (
          group.name.toLowerCase().includes(searchQuery.toLowerCase())
          || deliverable.name.toLowerCase().includes(searchQuery.toLowerCase())
        );

      // if task -> tag name matches query
      const isMatchedByTag = searchQuery && deliverable.tag?.name
        && (deliverable.tag?.name.toLowerCase().includes(searchQuery.toLowerCase()));

      // selected timerange intersects deliverable timerange
      const isWithinTimeframe = isTimeRangeIntersects(
        startDate, endDate,
        deliverable.startDate, deliverable.endDate
      );

      return (!searchQuery || isMatchedByName || isMatchedByTag) && isWithinTimeframe;
    });

    if (filteredDeliverables.length) {
      return result.concat([{
        ...group,
        deliverables: filteredDeliverables
      }]);
    }

    return result;
  }, []);
}
